import { Box, Grid, Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DescriptionIcon from '@mui/icons-material/Description';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Map from '../../assets/map-1.png';
import BigLogo from '../../assets/6.png';


const processSteps = [
  { icon: <LocationOnIcon />, label: 'Fill in an Address' },
  { icon: <DescriptionIcon />, label: 'Add a Few Property Details' },
  { icon: <AttachMoneyIcon />, label: 'Set Coverage and Deductible Amounts' },
  { icon: <CheckCircleIcon />, label: 'Select the Policy/Bind' }
];

const benefits = [
  { icon: <CheckCircleIcon />, label: 'Accurate Real time Quotes' },
  {
    icon: <CheckCircleIcon />,
    label: 'Have access to Upto 25+ Private Flood & NFIP Carrier'
  },
  {
    icon: <CheckCircleIcon />,
    label: 'Partner with Us to write both your personal and Commercial flood policies'
  },
  { icon: <CheckCircleIcon />, label: 'Watch your Flood Business Grow!' }
];

const BottomSection = () => {
  return (
    <Box className="app-layout-bottom">
      <Box
        className="app-container"
        sx={{
          px: {
            lg: '40px'
          },
          py: '40px'
        }}
      >
        <Typography fontSize="3rem" fontWeight={700}>
          Our Mission
        </Typography>
        <Box
          sx={{
            boxSizing: 'border-box',
            width: {
              xs: 'calc(100% - 32px)',
              sm: '60%'
            },
            mx: 'auto',
            mt: '40px',
            padding: {
              xs: '1.5rem',
              sm: '2rem'
            },
            borderRadius: '1rem',
            border: '1px solid rgba(255, 255, 255, 0.24)',
            bgcolor: '#1A3142'
          }}
        >
          <Typography fontSize="18px" maxWidth="md" mx="auto">
            Our Mission is to offer Personal and Commercial Flood Solutions to Agents and Agencies
            throughout the US. We aim to be a resource not only for regular flood insurance but also
            for hard to place cases.
          </Typography>
          <Typography fontSize="18px" maxWidth="md" mx="auto">
            Partner with us to generate flood quotes from up to 25+ Private and NFIP Carriers within
            seconds allowing you to Increase your flood Insurance Production by offering nearly
            every flood Insurer to your clients.
          </Typography>
        </Box>

        <Box
          sx={{
            pt: {
              xs: 4,
              md: 8
            },
            width: {
              xs: 'calc(100% - 32px)',
              sm: '65%'
            },
            mx: 'auto'
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Box sx={{ alignSelf: 'self-start' }}>
                <Typography
                  fontFamily="Roboto Condensed"
                  textAlign="left"
                  fontSize="2rem"
                  fontWeight={700}
                >
                  How Flood Quotes Works
                </Typography>
                {processSteps.map((step, index) => (
                  <Box
                    key={index}
                    display="flex"
                    alignItems={{
                      xs: 'start',
                      sm: 'center'
                    }}
                    my={2}
                  >
                    {step.icon}
                    <Typography fontSize="18px" ml={2}>
                      {step.label}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box>
                <Typography
                  fontFamily="Roboto Condensed"
                  textAlign="left"
                  fontSize="2rem"
                  fontWeight={700}
                >
                  How Flood Quotes Works
                </Typography>
                {benefits.map((benefit, index) => (
                  <Box
                    key={index}
                    display="flex"
                    alignItems={{
                      xs: 'start',
                      sm: 'center'
                    }}
                    my={2}
                  >
                    {benefit.icon}
                    <Typography textAlign="left" fontSize="18px" ml={2}>
                      {benefit.label}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ pt: 8, textAlign: 'center' }}>
          <Typography fontSize="3rem" fontWeight={700}>
            Top Flood Insurance Solution in{' '}
          </Typography>
          <Typography fontSize="3rem" fontWeight={700}>
            {' '}
            in{' '}
            <Typography fontSize="3rem" fontWeight={700} color="#4EB4E1" component="span">
              49 States
            </Typography>
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img src={Map} alt="Map" style={{ width: '60%', height: 'auto'  }} />
            <a href="https://www.nationalfloodinsurance.org/" target="_blank" rel="noopener noreferrer"><img src={BigLogo} alt="Logo" style={{ width: '38%', height: 'auto' }} /></a>
          </Box>

        </Box>
      </Box>
    </Box>
  );
};

export default BottomSection;
